<template>
    <div class="uk-container uk-container-expand">
        <router-link :to="{path: '/admin/boutique/create'}" class="btn btn-round my-3 border-0" style="background-color:#FFAB0E; color:#fff;" type="button" uk-toggle="target: #create_commande"><i class="fa fa-plus"></i>Ajouter une boutique</router-link>
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-2 p-2">
            <h4>Liste des boutiques</h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                    <thead>
                        <tr class="uk-card uk-card-default">
                            <th>N°</th>
                            <!-- <th>ID</th> -->
                            <th>Nom de  l'entreprise</th>
                            <th>Nom du responsable</th>
                            <th>Situation géographique</th>
                            <th>Contact de l'entreprise</th>
                            <th>type de paiement</th>
                            <th>Numéro de paiement</th>
                            <th>Date de création</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody v-if="access == 5 || access == 2">
                        <tr v-for="(boutique,num) in boutiques" :key="boutique.key">
                            <td>{{num+1}}</td>
                            <!-- <td>{{boutique.key}}</td> -->
                            <td>{{boutique.nom_boutique}}</td>
                            <td>{{boutique.nom_responsable}}</td>
                            <td>{{boutique.adresse}}</td>
                            <td>{{boutique.contact_boutique}}</td>
                            <td>{{boutique.type_paiement}}</td>
                            <td>{{boutique.adresse_paiement}}</td>
                            <td>{{boutique.created_at}}</td>
                            <td class="uk-flex">
                                <!-- :to="{path: '/EditBoutique/' + boutique.key }" v-bind:tooltip="boutique.key"  -->
                                <!-- <router-link  :to="{path: '/CreateSavePoint/' + boutique.key }" v-bind:tooltip="boutique.key" uk-toggle class="btn btn-default mr-1 uk-box-shadow-large" uk-tooltip="title: Ajouter; pos: top-left">
                                    <span class="" style="color: #5F5F5F" uk-icon="icon:plus; ratio: 0.8"></span>
                                </router-link> -->
                                <router-link  :to="{path: '/EditBoutique/' + boutique.key }" v-bind:tooltip="boutique.key" uk-toggle class="btn btn-default mr-1 uk-box-shadow-large" uk-tooltip="title: Modifier; pos: top-left">
                                    <span class="" style="color: #5F5F5F" uk-icon="icon:pencil; ratio: 0.8"></span>
                                </router-link>
                                <button @click="removeBoutique(boutique.key)" class="btn btn-default uk-box-shadow-large" uk-tooltip="title: Supprimer; pos: top-left">
                                    <span class="" style="color: #5F5F5F" uk-icon="icon:trash; ratio: 0.8"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>
<script>
import { db, dbstore, auth } from '../../main';
import Swal from "sweetalert2";

export default {
    data(){
        return{
            boutiques:[],
            boutique: {
                nom_boutique: null,
                nom_responsable: null,
                adresse: null,
                contact_boutique: null,
                type_paiement: null,
                adresse_paiement: null,
            },
            activeItem:null,
            access : 0
        }
    },

    methods: {
        removeBoutique(key){ dbstore.collection('boutiques').doc(key).delete() }
    },

    created () {
    this.access = this.$store.getters.user.data.role;
    const id = auth.currentUser.uid
    var start = new Date();
    start.setUTCHours(0,0,0,0);
    let refSotre
    if(this.access == 5 || this.access == 4 || this.access == 3 || this.access == 2){
    refSotre = dbstore.collection('boutiques')
    }else{
     refSotre = dbstore.collection('boutiques').where('commercial_id', '==', id)
    }
    refSotre.onSnapshot((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.boutiques.push({
            key: doc.id,
            nom_boutique: doc.data().nom_boutique,
            nom_responsable: doc.data().nom_responsable,
            adresse: doc.data().adresse,
            contact_boutique:doc.data().contact_boutique,
            type_paiement:doc.data().type_paiement,
            adresse_paiement:doc.data().adresse_paiement,
            id_proprio:doc.data().id_proprio,
            uuid:doc.data().uuid,
            created_at:doc.data().created_at,
            commercial_id:doc.data().commercial_id
        });
      });

    });

    // created for updateboutique
    var dbstoreRef = dbstore.collection('boutiques')
        dbstoreRef
        .get()
        .then((childSnapshot) => {
            const onData = childSnapshot.val();
            this.boutique = onData;
        })
        .catch(() => {
            console.log(dbstoreRef);
        });

  },
}
</script>
<style>

.uk-container {
    display: flex;
    flex-direction: column;
}


</style>